import React from 'react';
import { Layout } from '../../../queries/ats/layout/types';
import { classes } from '../../../utils/commonUtils';
import { ErrorBoundary } from '../../error-boundary';
import { AtsItemOverwrites } from '../ats-asset/atsAsset.interfaces';
import { SourceIndicator } from '../ats-asset/source-indicator/source-indicator';
import { AtsImage } from '../AtsImage';
import { AtsItem } from '../AtsItem';
import styles from './AtsPromo.module.scss';

interface AtsPromoProps {
  item: Layout.SectionItem;
  pattern: Layout.Pattern;
  overwrites?: AtsItemOverwrites;
}

export default function AtsPromo({ item, pattern, overwrites, ...rest }: AtsPromoProps) {
  const isLarge = pattern === Layout.PageSectionStylePattern.PROMO_WIDE_LARGE;

  if (item.type === 'title') {
    return (
      <AtsItem
        item={item}
        pattern={pattern}
        className={classes(styles.item, isLarge && styles.large)}
        overwrites={overwrites}
        {...rest}
      >
        <AtsImage className={styles.image} item={item} pattern={pattern} width={isLarge ? 1600 : 800} />
        <ErrorBoundary fallback={() => null}>
          <SourceIndicator title={item.title} />
        </ErrorBoundary>
      </AtsItem>
    );
  }

  return (
    <AtsItem
      item={item}
      pattern={pattern}
      className={classes(styles.item, isLarge && styles.large)}
      overwrites={overwrites}
      {...rest}
    >
      <AtsImage className={styles.image} item={item} pattern={pattern} width={Boolean(isLarge) ? 1600 : 800} />
    </AtsItem>
  );
}

function AtsPromoSkeleton({ pattern }: Pick<AtsPromoProps, 'pattern'>) {
  const isLarge = pattern === Layout.PageSectionStylePattern.PROMO_WIDE_LARGE;

  return <div className={classes(styles.skeleton, styles.item, isLarge && styles.large)} />;
}

AtsPromo.Skeleton = AtsPromoSkeleton;
